import styled from 'styled-components';
import ReactLoading from 'react-loading';

export const LoadingContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0; 
    bottom: 0;
    background-color: rgba(0,0,0,0.7);
    text-align: center;
    vertical-align: middle;
    z-index: 1000;
`;

export const LoadingAnimator = styled(ReactLoading)`
    left: 50%;
    position: absolute;
    transform: translateX(-50%) translateY(-50%);
    top: 50%;
`;